import { Form, useActionData, useNavigation } from "react-router";

export default function LoginForm() {
  //const [searchParams] = useSearchParams();
  const navigation = useNavigation();
  const validationErrors = useActionData();

  //const authMode = searchParams.get("mode") || "login";

  const submitBtnCaption = "Login";

  const isSubmitting = navigation.state !== "idle";

  return (
    <Form method="post" className="form" id="auth-form">
      <div className="icon-img">Locked-Symbol</div>
      <p>
        <label htmlFor="email">Email Address</label>
        <input id="email" name="email" />
      </p>
      <p>
        <label htmlFor="password">Password</label>
        <input type="password" id="password" name="password" />
      </p>
      {validationErrors && (
        <ul>
          {Object.values(validationErrors).map((error: any) => (
             <li key={error}>{error}</li>
          ))}
        </ul>
      )}
      <div className="form-actions">
        <button disabled={isSubmitting}>
          {isSubmitting ? "Authenticating..." : submitBtnCaption}
        </button>
      </div>
    </Form>
  );
}
